// lib/website.ts — мягкая валидация и нормализация website компании (U-22, §5.3).
// Зеркало backend CompanyCreateRequest/CompanyUpdateRequest @Pattern
// (Tech-Story-sled-V9-crm-feedback-2; D4 Data Clumps — единый источник на FE).

/**
 * Мягкий паттерн website: схема {@code https?://} опциональна, TLD обязателен
 * (домен без точки — «example»/«abc123» — отклоняется), latin-only (кириллица → false).
 */
export const WEBSITE_PATTERN =
  /^(https?:\/\/)?[A-Za-z0-9]([A-Za-z0-9.-]*[A-Za-z0-9])?(\.[A-Za-z]{2,})(\/.*)?$/;

/**
 * Проверяет website по мягкому паттерну (пустая строка — валидна).
 *
 * @param value значение поля «Сайт».
 * @return true если значение пустое или домен/URL соответствует канону §5.3.
 */
export function isValidWebsite(value: string): boolean {
  const trimmed = value.trim();
  return trimmed === '' || WEBSITE_PATTERN.test(trimmed);
}

/**
 * Добавляет {@code https://}-префикс, если схемы нет (U-22: «example.com» →
 * «https://example.com»). Пустое значение возвращается без изменений.
 *
 * @param value сырое значение поля.
 * @return нормализованное значение (со схемой или исходное).
 */
export function normalizeWebsite(value: string): string {
  const trimmed = value.trim();
  if (trimmed === '' || /^https?:\/\//.test(trimmed)) {
    return value;
  }
  return `https://${trimmed}`;
}
